import * as Yup from "yup";
import styled from "styled-components";
import { useFormik } from "formik";
import { ButtonRightCorner, ErrorWrapper, PageContainer } from "../../sharedStyles";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const newCompanyUserSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  password: Yup.string()
  .required("Password is required")
  .min(8, 'Password must have a minimum of 8 characters')
  .matches(/\d+/, "Password must contain at least one number")
  .matches(/[a-z]+/, "Password must contain lowercase character (a-z)")
  .matches(/[A-Z]+/, "Password must contain uppercase character (A-Z)")
  .matches(/[@$/!%*<>+#?&~()^:{}]+/, "Password must contain a special character like : @$/!%*<>+#?&~()^:{}"),
});

const CustomCard = styled.div`
  width: 36rem;
  min-height: 20rem;
`;

const NewCompanyUser = ({user}: any) => {
  const formik = useFormik({
    initialValues: {
      name: '',
      password: '',
    },
    validationSchema: newCompanyUserSchema,
    onSubmit: (values) => {
      console.log(values)
    },
    enableReinitialize: true,
  });

  const { errors, touched } = formik;

  return (
    <PageContainer className="d-flex align-items-center justify-content-center vh-100">
      <CustomCard>
        <Card>
          <CardContent className="pt-6">
            <form onSubmit={formik.handleSubmit}>
              <div className="mb-4">
                <Label htmlFor="name">Name</Label>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Your name"
                  onChange={formik.handleChange}
                  value={formik?.values?.name}
                />
                <ErrorWrapper>
                  {errors?.name && touched?.name ? errors?.name : ''}
                </ErrorWrapper>
              </div>
              <div className="mb-4">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  placeholder="Type your password"
                  onChange={formik.handleChange}
                  value={formik?.values?.password}
                />
                <ErrorWrapper>
                  {errors?.password && touched?.password ? errors?.password : ''}
                </ErrorWrapper>
              </div>
            </form>
          </CardContent>
          <CardFooter>
            <ButtonRightCorner>
              <Button
                onClick={formik.submitForm}
              >
                Save
              </Button>
            </ButtonRightCorner>
          </CardFooter>
        </Card>
      </CustomCard>
    </PageContainer>
  )
}

export default NewCompanyUser;
